module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-modal', {
    ref: "communityEditModal",
    attrs: {
      "id": "communityEditModal",
      "size": "lg",
      "title": _vm.$t('community.modal.edit'),
      "no-close-on-backdrop": ""
    },
    on: {
      "show": _vm.setCommunityEditData
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('b-form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.editCommunity($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('community.name'),
      "state": _vm.communityEditNameState,
      "feedback": _vm.communityEditNameFeedback
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "required": ""
    },
    model: {
      value: (_vm.communityEditData.name),
      callback: function($$v) {
        _vm.communityEditData.name = $$v
      },
      expression: "communityEditData.name"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('community.tag'),
      "state": _vm.communityEditTagState,
      "feedback": _vm.communityEditTagFeedback
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "required": ""
    },
    model: {
      value: (_vm.communityEditData.tag),
      callback: function($$v) {
        _vm.communityEditData.tag = $$v
      },
      expression: "communityEditData.tag"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('community.website.optional'),
      "state": _vm.communityEditWebsiteState,
      "feedback": _vm.communityEditWebsiteFeedback
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.communityEditData.website),
      callback: function($$v) {
        _vm.communityEditData.website = $$v
      },
      expression: "communityEditData.website"
    }
  })], 1)], 1)]), _vm._v(" "), _c('hr', {
    staticClass: "my-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "row font-weight-bold"
  }, [_c('div', {
    staticClass: "col col-12"
  }, [_vm._v(_vm._s(_vm.$t('community.gameServers')))])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.communityEditData && _vm.communityEditData.gameServers) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "35%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.serverInfo.hostname')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.serverInfo.port')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.serverInfo.name')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.serverInfo.password')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "5%"
    }
  }, [_vm._v(_vm._s(_vm.$t('misc.actions')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.communityEditData.gameServers), function(gameServer, index) {
    return _c('tr', {
      key: ((gameServer.hostname) + ":" + (gameServer.port))
    }, [_c('td', [_vm._v(_vm._s(gameServer.hostname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(gameServer.port))]), _vm._v(" "), _c('td', [(gameServer.name) ? _c('span', [_vm._v(_vm._s(gameServer.name))]) : _c('span', {
      staticClass: "text-muted font-italic"
    }, [_vm._v(_vm._s(_vm.$t('misc.notProvided')))])]), _vm._v(" "), _c('td', [(gameServer.password) ? _c('span', [_vm._v(_vm._s(gameServer.password))]) : _c('span', {
      staticClass: "text-muted font-italic"
    }, [_vm._v(_vm._s(_vm.$t('misc.notRequired')))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('b-btn', {
      attrs: {
        "variant": "danger",
        "size": "sm"
      },
      on: {
        "click": function($event) {
          _vm.removeCommunityGameServer(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" " + _vm._s(_vm.$t('button.delete')) + "\n                    ")])], 1)])
  })), _vm._v(" "), _c('tfoot', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.communityEditData.gameServers.length >= 10),
      expression: "communityEditData.gameServers.length >= 10"
    }]
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "35%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.serverInfo.hostname')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.serverInfo.port')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.serverInfo.name')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.serverInfo.password')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "5%"
    }
  }, [_vm._v(_vm._s(_vm.$t('misc.actions')))])])])], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.serverInfo.hostname'),
      "state": _vm.communityEditGameServerHostnameState,
      "feedback": _vm.communityEditGameServerHostnameFeedback,
      "description": _vm.$t('community.gameServers.hostname.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.communityEditGameServer.hostname),
      callback: function($$v) {
        _vm.communityEditGameServer.hostname = $$v
      },
      expression: "communityEditGameServer.hostname"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.serverInfo.port'),
      "state": _vm.communityEditGameServerPortState,
      "feedback": _vm.communityEditGameServerPortFeedback,
      "description": _vm.$t('community.gameServers.port.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "0",
      "max": "65535"
    },
    model: {
      value: (_vm.communityEditGameServer.port),
      callback: function($$v) {
        _vm.communityEditGameServer.port = $$v
      },
      expression: "communityEditGameServer.port"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.serverInfo.name'),
      "state": "success",
      "description": _vm.$t('community.gameServers.name.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.communityEditGameServer.name),
      callback: function($$v) {
        _vm.communityEditGameServer.name = $$v
      },
      expression: "communityEditGameServer.name"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.serverInfo.password'),
      "state": "success",
      "description": _vm.$t('community.gameServers.password.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.communityEditGameServer.password),
      callback: function($$v) {
        _vm.communityEditGameServer.password = $$v
      },
      expression: "communityEditGameServer.password"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col text-center"
  }, [_c('b-btn', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.addCommunityGameServer
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.add')) + "\n            ")])], 1)]), _vm._v(" "), _c('hr', {
    staticClass: "my-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "row font-weight-bold"
  }, [_c('div', {
    staticClass: "col col-12"
  }, [_vm._v(_vm._s(_vm.$t('community.voiceComms')))])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.communityEditData && _vm.communityEditData.voiceComms) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "35%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.serverInfo.hostname')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.serverInfo.port')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.serverInfo.name')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.serverInfo.password')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "5%"
    }
  }, [_vm._v(_vm._s(_vm.$t('misc.actions')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.communityEditData.voiceComms), function(voiceComms, index) {
    return _c('tr', {
      key: ((voiceComms.hostname) + ":" + (voiceComms.port))
    }, [_c('td', [_vm._v(_vm._s(voiceComms.hostname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(voiceComms.port))]), _vm._v(" "), _c('td', [(voiceComms.name) ? _c('span', [_vm._v(_vm._s(voiceComms.name))]) : _c('span', {
      staticClass: "text-muted font-italic"
    }, [_vm._v(_vm._s(_vm.$t('misc.notProvided')))])]), _vm._v(" "), _c('td', [(voiceComms.password) ? _c('span', [_vm._v(_vm._s(voiceComms.password))]) : _c('span', {
      staticClass: "text-muted font-italic"
    }, [_vm._v(_vm._s(_vm.$t('misc.notRequired')))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('b-btn', {
      attrs: {
        "variant": "danger",
        "size": "sm"
      },
      on: {
        "click": function($event) {
          _vm.removeCommunityVoiceComms(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" " + _vm._s(_vm.$t('button.delete')) + "\n                    ")])], 1)])
  })), _vm._v(" "), _c('tfoot', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.communityEditData.voiceComms.length >= 10),
      expression: "communityEditData.voiceComms.length >= 10"
    }]
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "35%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.serverInfo.hostname')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.serverInfo.port')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.serverInfo.name')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.serverInfo.password')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "5%"
    }
  }, [_vm._v(_vm._s(_vm.$t('misc.actions')))])])])], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.serverInfo.hostname'),
      "state": _vm.communityEditVoiceCommsHostnameState,
      "feedback": _vm.communityEditVoiceCommsHostnameFeedback,
      "description": _vm.$t('community.voiceComms.hostname.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.communityEditVoiceComms.hostname),
      callback: function($$v) {
        _vm.communityEditVoiceComms.hostname = $$v
      },
      expression: "communityEditVoiceComms.hostname"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.serverInfo.port'),
      "state": _vm.communityEditVoiceCommsPortState,
      "feedback": _vm.communityEditVoiceCommsPortFeedback,
      "description": _vm.$t('community.voiceComms.port.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "0",
      "max": "65535"
    },
    model: {
      value: (_vm.communityEditVoiceComms.port),
      callback: function($$v) {
        _vm.communityEditVoiceComms.port = $$v
      },
      expression: "communityEditVoiceComms.port"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.serverInfo.name'),
      "state": "success",
      "description": _vm.$t('community.voiceComms.name.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.communityEditVoiceComms.name),
      callback: function($$v) {
        _vm.communityEditVoiceComms.name = $$v
      },
      expression: "communityEditVoiceComms.name"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.serverInfo.password'),
      "state": "success",
      "description": _vm.$t('community.voiceComms.password.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.communityEditVoiceComms.password),
      callback: function($$v) {
        _vm.communityEditVoiceComms.password = $$v
      },
      expression: "communityEditVoiceComms.password"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col text-center"
  }, [_c('b-btn', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.addCommunityVoiceComms
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.add')) + "\n            ")])], 1)])])], 1), _vm._v(" "), _c('div', {
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group",
      "aria-label": "Community edit actions"
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.editCommunity
    }
  }, [_c('i', {
    staticClass: "fa fa-save",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.save')) + "\n        ")]), _vm._v(" "), _c('b-btn', {
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": _vm.hideCommunityEditModal
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.cancel')) + "\n        ")])], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a53aadf2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/communities/modals/CommunityEditModal.vue
// module id = 566
// module chunks = 0